(()=> {

  initSizeVideos(1)

  function initSizeVideos(index){
    let html = '';
    html += heading();
    html += '<div class="size-videos">';
    html += '<ul class="size-videos__model-menu"></ul>';
    html += '<div class="size-videos__model-info"></div>';
    html += `<video class="" src="${largestVideoSourceUrl(sizeVideosArr[index].videoDesktop)}" loop muted playsinline autoplay></video>`;
    html += "</div>";
     

    //let breadcrumbs = document.getElementsByClassName("breadcrumbs")[0];
    //breadcrumbs.insertAdjacentHTML("afterend", html)
    
    if(window.innerWidth > 900){
      document.getElementsByClassName("size-videos__container")[0].innerHTML = html;
    } else {
      if(document.getElementsByClassName('fit-video').length > 0){
        let fitVideoDiv = document.getElementsByClassName('fit-video')[0];
        let fitVideo = fitVideoDiv.innerHTML;
        fitVideoDiv.innerHTML = html;
        document.getElementsByClassName("size-videos__container")[0].innerHTML = fitVideo;
      }
    }

    buildModelMenu(index);
    addListeners();
    buildModelInfo(index);
  }

  function buildModelMenu(index){
    let html = '';
    sizeVideosArr.forEach( (video, i) => {
      let model = modelData.find(model => model.title.toLowerCase() == video.model.toLowerCase()) || ""
      let selected = (i == index) ? `class="size-selected"`:"";

      html += "<li>"
      html += `<button class="size-videos__btn" data-index="${i}" data-size="${video.size}" ${selected}>`
      html += `<img src="${model.image}" alt="${model.title}"/>`

      html += `<div>Size ${video.size}</div>`
      html += `<div>${video.model}</div>`

      html += "</button>"
      html += "</li>"
    })
    document.getElementsByClassName('size-videos__model-menu')[0].innerHTML = html;
  }

  function updateModelMenu(index){
    let buttons = Array.from(document.getElementsByClassName('size-videos__model-menu')[0].getElementsByTagName('button'));
    buttons.forEach( btn => {
      btn.classList.remove('size-selected');
    })
    buttons[index].classList.add('size-selected')
  }

  function addListeners(){
    // Add event listeners
    let container = document.getElementsByClassName('size-videos')[0];
    Array.from(container.getElementsByTagName('button')).forEach(btn => {
      btn.addEventListener('click', e => {
        updateModelMenu(btn.dataset.index);
        buildModelInfo(btn.dataset.index);
        let video = container.getElementsByTagName('video')[0];
        video.src = largestVideoSourceUrl(sizeVideosArr[btn.dataset.index].videoDesktop)
      })
    })
  }

  function buildModelInfo(index){
    let model = modelData.find(model => model.title.toLowerCase() == sizeVideosArr[index].model.toLowerCase());
    if(model){
      html = `${model.height} <span>&bull;</span> ${model.chest} <span>&bull;</span>  Waist: ${model.waist} <span>&bull;</span>  Hips: ${model.hips}`

      document.getElementsByClassName('size-videos__model-info')[0].innerHTML = html;
      return html
    }
  }

  function largestVideoSourceUrl(video){
    var res = video.sources.sort((a, b) => b.width-a.width);
    return res[0].url;
  }

  function heading(){
    if(sizeVideosHeading != ''){
      return `<h4 class="size-videos-heading">${sizeVideosHeading}</h4>`
    } else {
      return '';
    }
  }
})()